module.exports = {
  starBanner: require('./star_tile.png'),
  starTitle: require('./star_tile.png'),
  chromeIcon: require('./chrome_logo.png'),
  facebookIcon: require('./facebook.png'),
  instagramIcon: require('./instagram.png'),
  rightChevronIcon: require('./chevron-right-outline.png'),
  leftChevronIcon: require('./chevron-left-outline.png'),
  youtubeIcon: require('./youtubeIcon.png'),
  telegramIcon: require('./telegram.png'),
  phoneCallIcon: require('./phone-call.png'),
  whatsAppIcon: require('./whatsapp.png'),
  gmailIcon: require('./gmail.png'),
  loginDesktopBanner: require('./loginDesktop.png'),
  goodNewsBanner: require('./good-news.png'),
  individualSubjectPackageImage: require('./STAR-INDIVIDUAL-SUBJECTS.png'),
  proPackageImage: require('./STAR-PRO-PACKAGE.png'),
  basicPackageImage: require('./STAR-BASIC-PACKAGE.png'),
};
